<template>
    <div v-if="isLoading" class="w-100">
        <Message
            class="my-5 d-flex justify-content-center"
            loading
            message="資料讀取中，請稍候..."
        />
    </div>
    <div v-else-if="isError" class="w-100">
        <Message
            class="mt-5 mb-4 d-flex justify-content-center"
            message="資料載入失敗，請洽相關人員"
        />
    </div>
    <div v-else>
        <button class="btn btn-default btn-sm" @click.stop.prevent="$emit('delete', deletelist)">刪除</button>
        <div class="d-flex align-items-end">
            <div class="flex-grow-1">
                <table class="table datatable">
                    <thead>
                        <tr>
                            <th style="width:6%" class="text-center px-0">選取</th>
                            <th style="width:6%" class="text-center">序</th>
                            <th style="width:16%" class="text-center">條件項目</th>
                            <th style="width:12%" class="text-center">運算子</th>
                            <th style="width:60%" class="text-center">規則</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(data, i) in details" :key="`data-${i}`">
                            <td :key="`td1-${i}`" class="text-center py-0">
                                <div class="checkbox radio-inline mr-0 w-20">
                                    <input type="checkbox" :id="`type${i}`" :value="i" v-model="deletelist">
                                    <label :for="`type${i}`"></label>
                                </div>
                            </td>
                            <td :key="`td2-${i}`" class="text-center">{{i+1}}</td>
                            <td :key="`td3-${i}`">
                                <select
                                    class="form-select"
                                    v-model="data.detailkey"
                                    @change="changeType(data, i)"
                                >
                                    <option 
                                        v-for="(type, i) in typelist" 
                                        :key="`type-option-${i}`" 
                                        :value="type.value"
                                    >
                                        {{ type.text }}
                                    </option>
                                </select>
                            </td>
                            <td :key="`td4-${i}`">
                                <select
                                    class="form-select"
                                    v-model="data.operator"
                                    @change="changeOperator(data)"
                                >
                                    <option 
                                        v-for="(operator, i) in getOperatorList(data.detailkey)" 
                                        :key="`operator-option-${i}`" 
                                        :value="operator.value"
                                    >
                                        {{ operator.text }}
                                    </option>
                                </select>
                            </td>
                            <td :key="`td5-${i}`">
                                <v-select
                                    v-if="data.isSelect"
                                    v-model="data.values"
                                    class="multiple"
                                    :options="getOptionList(data.detailkey)"
                                    :reduce="(item) => item.value"
                                    label="text"
                                    multiple
                                    :closeOnSelect="false"
                                    :clearSearchOnSelect="false"
                                    @input="changeOption(data)"
                                >
                                    <div slot="no-options">沒有資料可供選擇 !</div>
                                </v-select>
                                <div v-else-if="data.isBetween" class="d-flex">
                                    <input
                                        class="form-control form-control-inline w-100 ml-0"
                                        :id="`min-${i}`"
                                        type="number"
                                        maxlength="20"
                                        v-model="data.min"
                                    />
                                    <label for="">～</label>
                                    <input
                                        class="form-control form-control-inline w-100 mr-0"
                                        :id="`max-${i}`"
                                        type="number"
                                        maxlength="20"
                                        v-model="data.max"
                                    />
                                </div>
                                <input
                                    v-else-if="data.isSingleInput"
                                    class="form-control form-control-inline w-100 mx-0" 
                                    id="reportName" 
                                    type="number" 
                                    maxlength="20"
                                    v-model="data.value"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <button 
                    class="btn btn-text btn-sm py-3" 
                    :disabled="isAddDisabled"
                    @click.stop.prevent="addDetail()"
                >
                    <i class="fa fa-plus-circle fa-2x"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Message from "@/desktop/components/Message.vue";
import { 
    getSpecialConditionDetailFormOptions,
    getCompanyOptions,
    getProductOptions,
} from "@/service";

export default {
    name: "SpecialConditionDetailTableForm",
    components: { 
        Message,
    },
    props: {
        details: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            isLoading: true,
            isError: false,
            deletelist: [],
            typelist: [],
            operatorlist: [],
            companylist: [],
            productlist: [],
            producttypelist: [],
            contracttypelist: [],
            currencytypelist: [],
            coverageyearperiodtypelist: [],
            unitlist:[],
        };
    },
    computed: {
        isAddDisabled() {
            return this.getValidateErrorInfo().length > 0;
        },
    },
    methods: {
        init() {
            if (this.details.length > 0) {
                this.details.forEach((data) => {
                    data["isSelect"] = this.getIsSelect(data.detailkey, data.operator)
                    data["isBetween"] = this.getIsBetween(data.operator)
                    data["isSingleInput"] = this.getIsSingleInput(data.detailkey, data.operator)
                });
            } else {
                this.addDetail();
            }
        },
        changeType(data, index) {
            data.values = [];
            data.value = "";
            data.min = "";
            data.max = "";
            data.operator = null;
            data["isSelect"] = this.getIsSelect(data.detailkey, data.operator)
            data["isSingleInput"] = this.getIsSingleInput(data.detailkey, data.operator)

            for (let i = 0; i < this.details.length; i++) {
                if (i == index) continue;
                if (data.detailkey == this.details[i].detailkey) {
                    this.$toast.info({ title: "條件項目不得重複，請重新選擇" });
                    data.detailkey = "";
                    this.$forceUpdate();
                    return;
                }
            }
            
            if (data.detailkey === "COMPANYID" && this.companylist.length == 0) {
                getCompanyOptions(this.$store.state.userInfo.id).then(result => {
                    if (result.header.status == "200" && result.body) {
                        this.companylist = result.body;
                    }
                });
            } else if (data.detailkey === "PRODUCTID") {
                let company = this.details.find((e) => e.detailkey === "COMPANYID");
                if (!company) {
                    this.$toast.info({ title: "請先選擇公司別" });
                    return;
                }

                getProductOptions(
                    this.$store.state.userInfo.id,
                    company.values
                ).then(result => {
                    if (result.header.status == "200" && result.body) {
                        this.productlist = result.body;
                    }
                });
            }
            this.$forceUpdate();
        },
        changeOperator(data) {
            data["isSelect"] = this.getIsSelect(data.detailkey, data.operator)
            data["isBetween"] = this.getIsBetween(data.operator)
            data["isSingleInput"] = this.getIsSingleInput(data.detailkey, data.operator)
            this.$forceUpdate()
        },
        changeOption(data,val) {
            // console.log("changeOption", val)
            // console.log("changeOption", data)
        },
        getOperatorList(key) {
            switch (key) {
                case "COMPANYID":
                case "PRODUCTID":
                case "PRODUCTTYPE":
                case "CONTRACTTYPE":
                case "CURRENCYTYPE":
                case "COVERAGEYEARPERIODTYPE":
                case "UNIT":
                    return this.operatorlist.filter((operator) => operator.value == 0 || operator.value == 1);
                case "TERMINABLEPERIODS":
                case "AGEPERIODS":
                case "COVERAGEEND":
                case "HAGE":
                case "PHAGE":
                case "CHAGE":
                    return this.operatorlist;
                default: 
                    return [];
            }
        },
        getOptionList(key) {
            switch (key) {
                case "COMPANYID":
                    return this.companylist;
                case "PRODUCTID":
                    return this.productlist;
                case "PRODUCTTYPE":
                    return this.producttypelist;
                case "CONTRACTTYPE":
                    return this.contracttypelist;
                case "CURRENCYTYPE":
                    return this.currencytypelist;
                case "COVERAGEYEARPERIODTYPE":
                    return this.coverageyearperiodtypelist;
                case "UNIT":
                    return this.unitlist;
                default: 
                    return [];
            }
        },
        getIsSelect(key, operator) {
            switch (key) {
                case "COMPANYID":
                case "PRODUCTID":
                case "PRODUCTTYPE":
                case "CONTRACTTYPE":
                case "CURRENCYTYPE":
                case "COVERAGEYEARPERIODTYPE":
                case "UNIT":
                    return operator != null;
                default: 
                    return false;
            }
        },
        getIsBetween(operator) {
            return operator == 2; // 2:介於
        },
        getIsSingleInput(key, operator) {
            switch (key) {
                case "TERMINABLEPERIODS":
                case "AGEPERIODS":
                case "COVERAGEEND":
                case "HAGE":
                case "PHAGE":
                case "CHAGE":
                    return operator != 2; // 2:介於
                default: 
                    return false;
            }
        },
        getValidateErrorInfo() {
            const TYPE_EMPTY_ERROR = "條件項目不得為空";
            const OPERATOR_EMPTY_ERROR = "運算子不得為空";
            const RULES_EMPTY_ERROR = "規則不得為空";

            for (let i = 0; i < this.details.length; i++) {
                if (!this.details[i].detailkey) {
                    return TYPE_EMPTY_ERROR;
                }
                if (this.details[i].operator == null) {
                    return OPERATOR_EMPTY_ERROR;
                }
                switch (this.details[i].detailkey) {
                    case "COMPANYID":
                    case "PRODUCTID":
                    case "PRODUCTTYPE":
                    case "CONTRACTTYPE":
                    case "CURRENCYTYPE":
                    case "COVERAGEYEARPERIODTYPE":
                    case "UNIT":
                        if (this.details[i].values.length == 0) {
                            return RULES_EMPTY_ERROR;
                        }
                        break;
                    case "TERMINABLEPERIODS":
                    case "AGEPERIODS":
                    case "COVERAGEEND":
                    case "HAGE":
                    case "PHAGE":
                    case "CHAGE":
                        if (this.details[i].operator == 2) {
                            if (!this.details[i].min  || !this.details[i].max) {
                                return RULES_EMPTY_ERROR;
                            }
                        } else {
                            if (!this.details[i].value) {
                                return RULES_EMPTY_ERROR;
                            }
                        }
                        break;
                    default: break;
                }
            }
            return "";
        },
        validate() {
            let errorInfo = this.getValidateErrorInfo();
            if (errorInfo.length > 0) {
                this.$toast.info({ title: errorInfo });
                return;
            } 
            return true;
        },
        addDetail() {
            this.details.push({
                detailkey: "",
                operator: null,
                values: [],
                valuestext: [],
                value: null,
                min: null,
                max: null,
                isSelect: false,
                isBetween: false,
                isSingleInput: false,
            })
            this.$forceUpdate()
        },
    },
    created() {
        this.init();
        let product = this.details.find((e) => e.detailkey === "PRODUCTID");
        let company = this.details.find((e) => e.detailkey === "COMPANYID");
        let companylist = company ? company.values : []
        getSpecialConditionDetailFormOptions(
            this.$store.state.userInfo.id, 
            companylist,
            !!product
        ).then(result => {
            if (result.header.status == "200" && result.body) {
                this.typelist = result.body.detailtypelist;
                this.operatorlist = result.body.operatorlist;
                this.companylist = result.body.companylist ? result.body.companylist : [];
                this.productlist = result.body.productlist ? result.body.productlist : [];
                this.producttypelist = result.body.producttypelist;
                this.contracttypelist = result.body.contracttypelist;
                this.currencytypelist = result.body.currencytypelist;
                this.coverageyearperiodtypelist = result.body.coverageyearperiodtypelist;
                this.unitlist = result.body.unitlist;
            } else {
                this.isError = true;
            }
            this.isLoading = false;
        });
    },
};
</script>

<style lang="scss" scoped>
.form-select {
    width: 100%;
    height: 40px;
    border: none;
    background: transparent;
    &:focus, &:focus-visible {
        border: none;
    }
}
.fa-plus-circle {
    font-size: 1.5em;
}
</style>